const CellComponent = ({ column, cell }) => {
  const Component = column.cell

  return <Component p={column?.padding} width={column?.width} data={cell} />
}

export default CellComponent
